import React, { useEffect, useState } from "react";
import * as Styles from "./styles";
import MaterialUI from "../../../../../material-UI";

interface Props {
  onClose: () => void;
  handleVincular: () => void;
  isLoading: boolean;
}

const Footer: React.FC<Props> = (props) => {
  return (
    <>
      <Styles.Container>
        <Styles.BodyText>
          Ao vincular o código da ficha, alguns campos de edição serão
          bloqueados, e os dados sobrepostos de acordo com as informações
          cadastradas na ficha do Crédito Fácil.
        </Styles.BodyText>
      </Styles.Container>
      <Styles.SecondContainer>
        <Styles.Button onClick={props?.onClose}>
          <Styles.LightTextBlue>Cancelar</Styles.LightTextBlue>
        </Styles.Button>
        <Styles.ButtonBlue onClick={props?.handleVincular}>
          {props.isLoading ? (
            <MaterialUI.CircularProgress size={22} style={{ color: "#fff" }} />
          ) : (
            <Styles.LightText>Vincular Código</Styles.LightText>
          )}
        </Styles.ButtonBlue>
      </Styles.SecondContainer>
    </>
  );
};

export default Footer;
